import { Grid, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import ShabashForm from './ShabashForm';
import ShabashHistory from './ShabashHistory';
import { variants } from '../../../variants/variants';
import useDetectKeyboardOpen from 'use-detect-keyboard-open';
import { useTheme } from '@emotion/react';

const ShabashDrawer = () => {
  const isKeyboardOpen = useDetectKeyboardOpen();
  const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <Grid container sx={{ margin: 0, padding: 2, height:'100%',overflowY:'scroll' }}>
      <Grid item xl={12} height={'38vh'} position={'sticky'}>
        <ShabashForm />
      </Grid>
      {/* {isKeyboardOpen ? null : (
        <>
          <Typography fontSize={variants.fontSize.HEADING} fontWeight={'bold'} mb={2}>
            Previous Shabash History
          </Typography> */}

          {/* <SearchBar
        // handleSearchChange={handleSearchChange}
        // value={search.searchTerm}
        sx={{ mb: 1, borderBottom: 1, borderColor: 'divider' }}
      /> */}
{/* 
          <br />
          <Grid item xs={12} height={'45.4vh'} sx={{ overflowY: 'auto', overflowX: 'hidden', position: 'sticky' }}>
            <ShabashHistory />
          </Grid>
        </>
      )} */}
    </Grid>
  );
};

export default ShabashDrawer;
